import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import ModalBasicLayout from "./ModalBasicLayout";
import TextField from "../Form/TextField";
import ContainerModalActions from "../Containers/ContainerModalActions";
import { useTranslationApp } from "../../lib/i18next";
import {
  BUTTON_CANCEL,
  FIELD_REQUIRED,
  BUTTON_REPORT_CONTENT,
  MODAL_REPORT_CONTENT_TITLE,
  MODAL_REPORT_CONTENT_DESCRIPTION,
  MODAL_REPORT_CONTENT_PLACEHOLDER,
} from "../../i18n/keysTranslations";

const ModalReportContent = ({
  modalOpen = false,
  onCloseModal = () => {},
  onSubmitReport = async () => {},
  isSubmitting = false,
}) => {
  const { t } = useTranslationApp();
  const {
    control,
    trigger,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      reason: "",
    },
  });

  const onCloseWithReset = () => {
    reset();
    onCloseModal();
  };

  const onSubmit = async () => {
    const isValid = await trigger();
    if (!isValid || isSubmitting) return;

    const reason = getValues("reason")?.trim();
    if (!reason) return;

    const response = await onSubmitReport({ reason });
    if (response?.ok) {
      reset();
    }
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseWithReset}
      fullWidth={true}
      maxWidth="sm"
      title={t(MODAL_REPORT_CONTENT_TITLE)}
      description={t(MODAL_REPORT_CONTENT_DESCRIPTION)}
      scroll="paper"
    >
      <Box sx={{ mt: 1 }}>
        <TextField
          name="reason"
          control={control}
          errors={errors}
          variant="filled"
          fullWidth
          multiline
          minRows={4}
          placeholder={t(MODAL_REPORT_CONTENT_PLACEHOLDER)}
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
          }}
        />
      </Box>
      <DialogActions sx={{ p: 0 }}>
        <ContainerModalActions
          propsSecondaryButton={{
            showButton: true,
            text: BUTTON_CANCEL,
            onClick: onCloseWithReset,
          }}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_REPORT_CONTENT,
            onClick: onSubmit,
            loading: isSubmitting,
          }}
        />
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default ModalReportContent;
